import React from 'react'

function HintsText() {
  return (
<div className='long-form text-gray-200 font-garamond text-left text-lg'>
	<p><strong>WRITING YOUR SUBMISSION</strong></p>
	<p>Write something fun and cool. The more imaginative, the better. The dungeon in which your secret
		door appears is an interplanar prison; incorporate that if you wish. People are more likely to vote for
		something fun, new, exciting, etc.</p>
	<p>Use Word or some other similar app. You're going to copy and paste your text into the contest
		form, so pretty much any text editor will do.</p>
	<p>Proofread your work. Get it edited, use spell check and grammar check. A lot of typos and bad
		sentences will turn potential voters off.</p>
	<p>Remember, though, no AI, and detection of such will be cause for rejection.</p>
	<p><strong>CREATING YOUR MAP</strong></p>
	<p>Your dungeon needs a map.</p>
	<p>Stick to a single image that fits an 8.5x11" format.</p>
	<p>Hand drawn is fine, or use Dungeon Alchemist or similar apps.</p>
	<p>You will upload your map file into the submission page.</p>
	<p><strong>CREATING YOUR VIDEO</strong></p>
	<p>Your video will draw people in to check out and vote for your submission. Make it fun, so voters
		will want to check out your whole submission.</p>
	<p>You're pushing yourself as well as your submission. Tell people about yourself, why you love
		gaming, why you entered the contest, and what's special about your secret door submission.</p>
	<p>Phone cameras are fine. Aim for a minute or less.</p>
	<p>Upload the video you shoot to YouTube or other host site so you can share the link to the
		contest. You will paste that link into the submission page.</p>
	<p><strong>CREATING YOUR THUMBNAIL</strong></p>
	<p>Browsing voters will see your thumbnail first; make it something exciting that will get their
		attention.</p>
	<p>Thumbnails are typically 1280 x 720 pixels. For YouTube, thumbnail sizes
			are&nbsp;1280 x 720 pixels, with a minimum width of 640 pixels. The dimensions use an aspect ratio of 16:9.
			Stick to a maximum file size of 2 MB</p>
	<p>Use Canva or other online apps, whatever makes an interesting thumbnail that draws voters in!</p>
	<p><strong>GETTING VOTES</strong></p>
	<p>That's the trick. Reach out to your friends, and so on, share the link to your submission, get
		out there and drive people to view and vote for your submission. Use all your social media accounts to drive
		people to view your submission. Good luck!</p>
</div>
  )
}

export default HintsText

